// @core/api/endpoints/booking/resolve_booking_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveBookingContextRequest,
  ResolveBookingContextResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Resolve booking context
 * Resolves the effective booking policy for a scope entity by merging the policy hierarchy. Returns merged policy, available numbering schemes, and allowed booking types.
 */
export async function ResolveBookingContext(
  data: ResolveBookingContextRequest,
  options?: RequestOptions
): Promise<ResolveBookingContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/bookings/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveBookingContextResponse>(requestPath, data, requestOptions);
}
